import { Component } from "@angular/core";

@Component({
    selector: "app-status-legend",
    templateUrl: "./status-legend.component.html",
    styleUrls: ["./status-legend.component.scss"],
})
export class StatusLegendComponent {}
